export var StepProgressUnit;
(function (StepProgressUnit) {
    StepProgressUnit["STEP_PROGRESS_UNIT_BYTES"] = "bytes";
    StepProgressUnit["STEP_PROGRESS_UNIT_OBJECTS"] = "objects";
    StepProgressUnit["STEP_PROGRESS_UNIT_TABLES"] = "tables";
})(StepProgressUnit || (StepProgressUnit = {}));
